import { Text } from 'foundations-components/components/Text';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import unescapedText from 'I18n/utils/unescapedText';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useHistory } from 'react-router-dom';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { Paths } from '../../constants/paths';
import { useGates } from '../../hooks/useGates';
import { useCollectionQuery } from '../../search-results/hooks/useCollectionQuery';
import { useSearchResultsPageMetadata } from '../../search-results/hooks/useSearchResultsPageMetadata';
import { MarketplaceLinkParser } from '../MarketplaceLinkParser';
import { UnifiedHeader } from './UnifiedHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function SearchResultsPageHeader() {
  var _params$get, _collectionResult$dat;
  const gates = useGates();
  const collectionResult = useCollectionQuery();
  const isCollection = !!collectionResult.data;
  const {
    heading
  } = useSearchResultsPageMetadata();
  const params = useSearchParams();
  const history = useHistory();
  const tab = (_params$get = params.get('PRODUCT_TYPE', {
    allowedValues: ['APP', 'AGENT', 'SOLUTIONS_PARTNER_PROFILE']
  })) !== null && _params$get !== void 0 ? _params$get : 'ALL';
  const collectionDescription = (_collectionResult$dat = collectionResult.data) === null || _collectionResult$dat === void 0 ? void 0 : _collectionResult$dat.description;
  const showSearchTabs = gates.solutionsSpringSpotlight && history.location.pathname === Paths.SEARCH_RESULTS;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UnifiedHeader, {
      dataTestId: "search-page-header",
      backBreadcrumb: !isCollection,
      title: heading,
      subtitle: collectionDescription ? /*#__PURE__*/_jsx(MarketplaceLinkParser, {
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          typography: "body-100",
          children: /*#__PURE__*/_jsx(SanitizedText, {
            body: collectionDescription,
            WrapperComponent: "span"
          })
        })
      }) : undefined,
      pathKey: isCollection ? 'FEATURED_COLLECTION' : 'SEARCH_RESULTS'
    }), showSearchTabs && /*#__PURE__*/_jsxs(Tabs, {
      selected: tab,
      onSelectedChange: e => {
        params.set('PRODUCT_TYPE', e.target.value, {
          defaultValue: 'ALL',
          historyMethod: 'replace'
        });
      },
      children: [/*#__PURE__*/_jsx(Tab, {
        tabId: "ALL",
        title: unescapedText('marketplaceStorefront.searchTab.all')
      }), /*#__PURE__*/_jsx(Tab, {
        tabId: "APP",
        title: unescapedText('marketplaceStorefront.searchTab.apps')
      }), /*#__PURE__*/_jsx(Tab, {
        tabId: "AGENT",
        title: unescapedText('marketplaceStorefront.searchTab.agents')
      }), /*#__PURE__*/_jsx(Tab, {
        tabId: "SOLUTIONS_PARTNER_PROFILE",
        title: unescapedText('marketplaceStorefront.searchTab.solutionsPartners')
      })]
    })]
  });
}